// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pagiNav{width:100%}", "",{"version":3,"sources":["webpack://./src/components/Pagination/Pagination.scss"],"names":[],"mappings":"AAEA,SACE,UAAA","sourcesContent":["// sass-lint:disable-all\n\n.pagiNav{\n  width:100%\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
